<div
  style="position: relative; direction: ltr"
  class="chart"
  [style.height.px]="height"
>
  <canvas
    [id]="id"
    #piechartcanvas
    class="relative"
    [attr.width]="width"
    [attr.height]="height"
  ></canvas>
  <div
    [id]="'chart-overlay'"
    [ngStyle]="isLoading ? { display: 'block' } : { display: 'none' }"
  ></div>
</div>
